
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-background flex items-center">
      <div className="container-custom text-center">
        <h1 className="text-6xl font-bold text-brand-blue dark:text-brand-orange mb-4">404</h1>
        <h2 className="text-2xl font-medium text-foreground mb-8">Page non trouvée</h2>
        <p className="text-muted-foreground mb-8">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <Link 
          to="/"
          className="inline-flex items-center px-6 py-3 rounded-lg bg-gradient-to-r from-brand-blue to-brand-orange text-white hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
